module.exports = __webpack_public_path__ + "static/img/premium-metal-card.c26271c.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/cards/premium-metal-card.png
// module id = X7ts
// module chunks = 27